<div class="navigate-left step{{step}}">
    <div class="divider"></div>
    <div class="grid" *ngIf="step===1">

        <div class="title step1">Welcome to Rubii.</div>
        <div class="content">
            The following few steps will guide you to get Rubii up and running in no time
        </div>
        <div class="content">
            If you have any questions, feel free to use the Help button in the bottom left
        </div>
    </div>
    <div class="grid" *ngIf="step===2">

        <div class="title step2">Connect your data sources.</div>
        <div class="content">
            In order to be able to track your campaigns, you need to connect at least one data source
        </div>
        <div class="content">
            Choose one of the following data sources
        </div>
    </div>
    <div class="grid" *ngIf="step===3">

        <div class="title step3">Invite your team.</div>
        <div class="content">
            Rubii works best with your team on board.
        </div>
        <div class="content">
            You can invite new users and set up different permissions according to their role in your business
        </div>
    </div>
    <div class="stepper">
        <div class="avatar" *ngIf="step === 1">
            <img src="assets/images/welcome.svg" />
        </div>
        <div class="datasource" *ngIf="step === 2">
            <img src="assets/images/datasource.svg" />
        </div>
        <div class="invite-team" *ngIf="step === 3">
            <img src="assets/images/invite_team.svg" />
        </div>
        <div class="steps">
            <div class="step{{step===1?' active':''}}" (click)="clickStep(1);">

            </div>
            <div class="step{{step===2?' active':''}} middle" (click)="clickStep(2);">

            </div>
            <div class="step{{step===3?' active':''}}" (click)="clickStep(3);">

            </div>
        </div>
    </div>
</div>
<div class="navigate-right step{{step}}">
    <app-datasource *ngIf="step===2"></app-datasource>
    <app-roles *ngIf="step === 3"></app-roles>
    <div class="table" *ngIf="step === 3">

        <ng-container *ngFor="let user of newUsers; let i = index">
            <form [formGroup]="newUserFormGroups[i]">
                <table>
                    <tbody>
        <tr style="border: 0px">

            <td style="border: 0px">
                <div style="width:50%; display: inline-block">
                    <mat-form-field>
                        <input type="text" matInput color="primary" formControlName="firstname" placeholder="Firstname">
                        <mat-error *ngIf="newUserFormGroups[i].get('firstname').errors && (newUserFormGroups[i].get('firstname').touched || newUserFormGroups[i].get('firstname').dirty)">
                            Please enter a valid first name
                        </mat-error>
                    </mat-form-field>
                </div>
                <div style="width: 50%; display: inline-block">
                    <mat-form-field>
                        <input type="text" matInput color="primary" formControlName="lastname" placeholder="Lastname">
                        <mat-error *ngIf="newUserFormGroups[i].get('lastname').errors && (newUserFormGroups[i].get('lastname').touched || newUserFormGroups[i].get('lastname').dirty)">
                            Please enter a valid last name
                        </mat-error>
                    </mat-form-field>
                </div>
            </td>
            <td style="border: 0px; text-align: left">
                <mat-form-field style="width:80%">
                    <input type="email" matInput color="primary" formControlName="email" placeholder="Email">
                    <mat-error *ngIf="newUserFormGroups[i].get('email').errors && (newUserFormGroups[i].get('email').touched || newUserFormGroups[i].get('email').dirty)">
                        Please enter a valid email
                    </mat-error>
                </mat-form-field>
            </td>
            <td style="border: 0px">
                <mat-grid-list style="margin-top: -1rem" class="user-grid-list" cols="3" rowHeight="{{72 | px2rem}}">
                    <mat-grid-tile>
                        <div style="cursor: pointer" class="role-icon {{user.roles.includes(shared.dicts.UserRoles.ADMIN)?'highlight': 'disabled'}}" (click)="addRoleToUser(i, shared.dicts.UserRoles.ADMIN);">
                            <img src="assets/images/admin_{{user.roles.includes(shared.dicts.UserRoles.ADMIN)?'active':'disabled'}}.svg" alt="Admin">
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div style="cursor: pointer; " class="role-icon  {{user.roles.includes(shared.dicts.UserRoles.TRADER)?'highlight': 'disabled'}}" (click)="addRoleToUser(i, shared.dicts.UserRoles.TRADER);">
                            <img src="assets/images/trader_{{user.roles.includes(shared.dicts.UserRoles.TRADER)?'active':'disabled'}}.svg" alt="Trader">
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div style="cursor: pointer" class="role-icon  {{user.roles.includes(shared.dicts.UserRoles.AM)?'highlight': 'disabled'}}" (click)="addRoleToUser(i, shared.dicts.UserRoles.AM);">
                            <img src="assets/images/am_{{user.roles.includes(shared.dicts.UserRoles.AM)?'active':'disabled'}}.svg" alt="Account Manager">
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-error *ngIf="roleErrors[i]">
                    Please select at least one role.
                </mat-error>
                <mat-error *ngIf="messages[i]">
                    {{messages[i]}}
                </mat-error>
            </td>
            <td class="action-col" style="text-align: left">
                <button mat-icon-button style="margin-top: -1rem" color="{{succeeded[i]?'accent':'primary'}}" (click)="removeUser(i)"><mat-icon>{{succeeded[i]?'check':'close'}}</mat-icon></button>
            </td>
        </tr>
                    </tbody>
                </table>
            </form>
        </ng-container>

        <button mat-button color="primary" (click)="addMore()">
            <mat-icon>add</mat-icon>&nbsp;<div style="display: inline-block">Add More</div>
        </button>
    </div>
</div>

<button mat-raised-button (click)="next()" color="primary" class="rubii-btn navigate-btn">{{step!==3?'Next':'Done'}}</button>





